import { Component, inject } from '@angular/core';
import { OnDestroy, OnInit } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { RouterOutlet } from '@angular/router';
import { Router } from '@angular/router';

import { AppUpdateService } from './core/services/app-update.service';
import { AppUpdateComponent } from './reusable-elements/misc/app-update/app-update.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AppUpdateComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  public appUpdateService = inject(AppUpdateService);
  private unsubscribe: (() => void) | null = null;

  constructor(
    private auth: Auth,
    private router: Router
  ) {}

  ngOnInit() {
    this.unsubscribe = onAuthStateChanged(this.auth, (user) => {
      if (!user) {
        // Don't redirect to login if user is on authentication-related routes
        const currentUrl = this.router.url;
        const exemptRoutes = ['/login', '/forgotpassword', '/usermanagement', '/resubscribe'];
        const isExemptRoute = exemptRoutes.some((route) => currentUrl.startsWith(route));

        if (!isExemptRoute) {
          this.router.navigate(['/login']);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
}
